// React
import React, { useState, useContext, useEffect } from "react";
// React
// CSS
import styles from "./Profile.module.css";
// CSS
// Components
import User from "./User/User";
import Wallet from "./Wallet/Wallet";
// Components
// Models
import { I_Profile } from "../../Models/interfaces";
// Models
// Services
import { getUserProfile_Service } from "../../Services/Profile/get/getUserProfile_Service";
// Services
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Images
import { eNamadIMG, sliderPlace } from "../../Images/images";
// Images
// Data
import { profileBtns } from "../../Data/profileBtns";
// Data
// Modules
import { Link } from "react-router-dom";
// Modules
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
// Skeleton

const Profile = () => {
  // States
  const [userStatus, setUserStatus] = useState<I_Profile>({
    city: {
      id: 0,
      name: "",
    },
    city_id: 0,
    code: "",
    Description: "",
    fullName: "",
    gift_wallet: 0,
    grade: { id: 0, title: "" },
    grade_id: 2,
    id: 0,
    is_admin: 0,
    Last_version: "",
    phone: "0",
    unread_notif: "",
    wallet: 0,
    profile_image_id: "",
    profile_pic: "",
    userName: "",
  });
  //
  const [isPending, setIsPending] = useState<boolean>(true);
  //
  const [isError, setIsError] = useState<boolean>(false);
  // States

  //   Constants
  const userToken = useContext(UserTokenContext);
  //   Constants

  // HELPERS
  // HELPERS

  // LifeCycles
  useEffect(() => {
    if (userToken === "init" || "") return;
    getUserProfile_Service(userToken)
      .then(({ data: { data } }) => {
        setUserStatus(data);
        // console.log(data);
        setIsPending(false);
        setIsError(false);
      })
      .catch((err: any) => {
        console.log(err);
        setIsPending(false);
        setIsError(true);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken]);
  //
  // LifeCycles
  return (
    <div className={`${styles.profileContainer} overflow-y-scroll`}>
      <img src={sliderPlace} alt="" className=" w-full h-40 relative " />
      <User data={userStatus} isError={isError} isPending={isPending} />
      <Wallet
        walletData={{
          wallet: userStatus.wallet,
          giftWallet: userStatus.gift_wallet,
        }}
      />

      {/* <Link
        to={"/profile/tickets"}
        className={`${styles.supportBtn} mt-2 text-center flex items-center justify-center w-full`}
      >
        <span className="mx-4 w-full py-3 mt-2 rounded-xl text-white">
          تیکت و پشتیبانی
        </span>
      </Link> */}
      <Link
        to={"/profile/device-manager"}
        className={`${styles.supportBtn}  mt-2 text-center flex items-center justify-center w-full`}
      >
        <span className="mx-4 w-full py-3 mt-2 rounded-xl text-white !bg-[#009687]">
          لیست دستگاه های فعال
        </span>
      </Link>

      <div
        className={`${
          styles.buttonsContainer
        } h-max flex flex-row items-center justify-between flex-wrap mx-4 ${
          window.innerWidth > 600 ? "overflow-hidden" : "overflow-y-scroll"
        } p-1 `}
      >
        {isPending ? (
          <>
            <SkeletonTheme
              baseColor="rgba(126, 58, 229 , 0.1)"
              highlightColor="rgba(126, 0, 229, 0.6)"
            >
              <p>
                <Skeleton
                  count={1}
                  width={"calc(100vw - 2rem)"}
                  height={"5vh"}
                  style={{ marginTop: "1rem" }}
                />
              </p>
            </SkeletonTheme>
          </>
        ) : (
          <>
            <div className="w-full flex items-center justify-between flex-wrap">
              {profileBtns.map((item) => (
                <Link
                  to={item.routeToNavigate}
                  key={item.backgroundGradient}
                  className={`${styles.btn} flex flex-col items-center justify-evenly rounded-2xl mt-4 `}
                  style={{
                    background: `${item.backgroundGradient}`,
                    boxShadow: `0px 0px 5px 1px ${item.borderGradiant}`,
                  }}
                  onClick={() => {
                    if (!item.onClick) return;

                    item.onClick();
                  }}
                >
                  <item.Icon className={"text-white text-2xl"}></item.Icon>
                  <p className="text-white !text-xs">{item.name}</p>
                </Link>
              ))}
            </div>
            <div className="w-full p-4 my-4 flex items-center justify-around flex-row-reverse border-solid border-2 border-[#828282] rounded-xl mt-8">
              <img
                src={eNamadIMG}
                alt=""
                className="w-[7rem] object-contain "
              />
              <div className="flex flex-col items-center justify-center  mr-4">
                <p className="w-max text-center text-sm">
                  جهت اطمینان بیشتر
                  <br />
                  اینجا کلیک کنید
                </p>
                <button
                  className="bg-[#9d00ff] text-white py-1.5 px-6 rounded-lg text-sm mt-2"
                  onClick={() => {
                    window.location.href = "https://amoozeshmelli.com/symbols";
                  }}
                >
                  اطلاعات بیشتر
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Profile;
